<template>
    <span class="m4" @mouseover="show = 'copy'"><a @click.prevent.stop="$copyText(str); settext('copied!')"><i class="fa fa-copy fa-sm"></i> {{show}}</a> </span>
</template>
<script>
export default {
    name: 'copy',
    props: ['str'],
    data(){
        return {
            show: ''
        }
    },
    methods: {
        settext(txt){
            this.$set(this, 'show', txt)
            setTimeout(()=>this.$set(this, 'show', ''), 2000)
        }
    }
}
</script>